<template>
      <div v-if="this.$route.query['error']" class="pa-5 justify-center align-center">
        <div>В работе страницы произшел сбой:
        {{error}}</div>
        <v-btn @click.stop="cancel">Вернуться назад</v-btn>
    </div>
</template>

<script>
export default {

    props: {
        result: {
            type: String,
        },
        query: {
            type: Object,
        }
    },
    computed: {
            error() {
                return this.$route.query['error'] || this.errorMessage
            }
    },
    methods: {

        newRedirect() {

            if(!this.result) return

            let resultQuery = { ...this.$route.query, ...this.query, [this.result]: true }
            
            let baseUrl = window.location.toString().split('?')[0]
            let queryString = Object.entries(resultQuery).map(entry => entry.join('=')).join('&')
            window.location = [baseUrl, queryString].join('?')

        }

    },

    created() {

        if (this.isAndroid || this.isIOS) {
            this.newRedirect()
        }
       
        
    }
}
</script>

<style>

</style>